export default {
  ShortText: 'shortText',
  LongText: 'longText',
  Date: 'date',
  Email: 'email',
  ImageChoice: 'imageChoice',
  SingleChoice: 'radioButton',
  MultipleChoice: 'checkBox',
  Link: 'link',
  Nps: 'nps',
  Slider: 'slider',
  SortList: 'sortList',
  Number: 'number',
  Matrix: 'matrix',
  Phone: 'phone',
  Dropdown: 'dropDown',
};
